(() => {
  // app/scripts/common/section/product-template.js
  var ProductTemplate = {
    onLoad: function() {
      let { container } = this;
      this.elms = {
        thumbnailSliderContainer: container.querySelector("#slider-thumb-media"),
        mainSliderContainer: container.querySelector("#slider-main-media"),
        priceElement: container.querySelector(".js-price"),
        priceCompareElement: container.querySelector(".js-price-compare"),
        formAddToCart: container.querySelector("form[action*='/cart/add']"),
        selectMaster: container.querySelector("select#product_select"),
        ingredientTabElements: container.querySelectorAll(".js-ingredient-tab"),
        ingredientsContainer: container.querySelector(".js-product-ingredients"),
        productBackground: container.querySelector(".product-background"),
        inputUpsellVariants: container.querySelector("input[name='upsell_variants']"),
        labelSale: container.querySelector(".label_ui-sale"),
        giftBox: container.querySelector(".js-gift-box"),
        bundleProductsContainer: container.querySelector(".js-bundle-products")
      };
      if (this.container.hasAttribute("data-robe-template")) {
        this.groupVariantImages = JSON.parse(this.container.querySelector("script[data-robe-json]").innerHTML || {});
      }
      if (this.container.querySelector("[data-gift-box]")) {
        this.giftBox = JSON.parse(this.container.querySelector("[data-gift-box]").innerHTML);
      }
      this.firstVariantChange = false;
      this.initMedia();
      if (theme.product.variants.length > 1) {
        AT.linkOptions(container.querySelector(".js-product-swatch"), theme.product, this.handleVariantChange.bind(this));
      } else {
        const variant = theme.product.variants[0];
        this.giftBox && this.changeGiftBox(this.giftBox[variant.id]);
      }
      if (theme.product.available) {
        this.initFormAddToCart();
        AT.initInputQuantity(container.querySelector(".js-input-quantity"));
      }
      this.initOpenModalIngredients();
    },
    initOpenModalIngredients() {
      let { container } = this;
      let openButton = container.querySelector(".js-btn-ingredients");
      if (!openButton) {
        return;
      }
      let ingredientsModal = container.querySelector("#modal-ingredients");
      ingredientsModal.querySelectorAll(".js-modal-close").addEvents("click", () => {
        ingredientsModal.removeClass("is-open");
        AT.enableScroll();
      });
      openButton.addEvent("click", () => {
        ingredientsModal.addClass("is-open");
        AT.disableScroll();
      });
    },
    initMedia() {
      if (theme.product.images.length === 1) {
        return;
      }
      let { thumbnailSliderContainer, mainSliderContainer } = this.elms;
      thumbnailSliderContainer.addClass("visibility-hidden");
      (() => {
        let config = JSON.parse(thumbnailSliderContainer.querySelector("[data-tns-config]").innerHTML);
        config.onInit = () => {
          thumbnailSliderContainer.querySelector(".js-tns-controls").removeClass("d-none");
          thumbnailSliderContainer.removeClass("visibility-hidden");
        };
        let isDesk = false;
        let isMobile = false;
        if (window.innerWidth > 992) {
          config.axis = "vertical";
          isDesk = true;
        } else {
          config.axis = "horizontal";
          isMobile = true;
        }
        this.thumbSlider = tns(config);
        window.addEvent("resize", () => {
          if (window.innerWidth > 992 && !isDesk) {
            config.axis = "vertical";
            isDesk = true;
            isMobile = false;
            this.thumbSlider.destroy();
            this.thumbSlider = tns(config);
            mainSliderContainer.dispatchEvent(new CustomEvent("rebuild"));
          } else if (window.innerWidth < 992 && !isMobile) {
            config.axis = "horizontal";
            isDesk = false;
            isMobile = true;
            this.thumbSlider.destroy();
            this.thumbSlider = tns(config);
            mainSliderContainer.dispatchEvent(new CustomEvent("rebuild"));
          }
        });
      })();
      (() => {
        let config = JSON.parse(mainSliderContainer.querySelector("[data-tns-config]").innerHTML);
        this.mainSlider = tns(config);
        mainSliderContainer.addEvent("rebuild", () => {
          this.mainSlider.destroy();
          this.mainSlider = tns(config);
        });
      })();
    },
    handleVariantChange(variant) {
      let {
        priceElement,
        priceCompareElement,
        selectMaster,
        ingredientTabElements,
        ingredientsContainer,
        productBackground,
        inputUpsellVariants,
        labelSale,
        thumbnailSliderContainer,
        mainSliderContainer,
        bundleProductsContainer,
        formAddToCart
      } = this.elms;
      formAddToCart.querySelector("input[name='variantTitle']").value = variant.name;
      if (labelSale) {
        if (variant.compare_at_price > 0) {
          labelSale.removeClass("d-none");
        } else {
          labelSale.addClass("d-none");
        }
      }
      priceElement.innerHTML = variant.price.toCurrency();
      if (!!variant.compare_at_price) {
        priceCompareElement.innerHTML = variant.compare_at_price.toCurrency();
        priceCompareElement.removeClass("d-none");
      } else {
        priceCompareElement.addClass("d-none");
      }
      if (this.container.hasAttribute("data-robe-template")) {
        if (this.firstVariantChange) {
          this.mainSlider.destroy();
          this.thumbSlider.destroy();
          let mainSliderItemTemplate = mainSliderContainer.querySelector(".js-slider-list").firstElementChild.cloneNode(true);
          let thumbSliderItemTemplate = mainSliderContainer.querySelector(".js-slider-list").firstElementChild.cloneNode(true);
          mainSliderContainer.querySelector(".js-slider-list").innerHTML = "";
          thumbnailSliderContainer.querySelector(".js-slider-list").innerHTML = "";
          this.groupVariantImages[variant.id].forEach((img) => {
            mainSliderItemTemplate.querySelector("img").src = AT.getSizedImageUrl(img, "500x");
            mainSliderContainer.querySelector(".js-slider-list").append(mainSliderItemTemplate.cloneNode(true));
            thumbSliderItemTemplate.querySelector("img").src = AT.getSizedImageUrl(img, "100x");
            thumbnailSliderContainer.querySelector(".js-slider-list").append(thumbSliderItemTemplate.cloneNode(true));
          });
          this.initMedia();
        }
      } else {
        if (!!variant.featured_image) {
          this.mainSlider?.goTo(+variant.featured_image.position - 1);
        }
      }
      selectMaster.value = variant.id;
      if (inputUpsellVariants) {
        [...selectMaster.options].find((option) => {
          if (option.value == variant.id) {
            inputUpsellVariants.value = option.dataset.upsell;
            return true;
          }
        });
      }
      if (ingredientsContainer) {
        let hasIngredientTab = [...ingredientTabElements].some((element) => {
          if (element.dataset.tabId == variant.id) {
            ingredientsContainer.querySelector(".js-ingredient-tab.active").removeClass("active");
            element.addClass("active");
            ingredientsContainer.removeClass("d-none");
            productBackground.style.backgroundSize = "contain";
            return true;
          }
          return false;
        });
        if (!hasIngredientTab) {
          ingredientsContainer.addClass("d-none");
          productBackground.style.backgroundSize = "cover";
        }
      }
      this.firstVariantChange = true;
      this.giftBox && this.changeGiftBox(this.giftBox[variant.id]);
      bundleProductsContainer && this.changeBundleProducts(variant.id);
    },
    changeGiftBox(giftBoxVariant) {
      let { giftBox } = this.elms;
      if (!giftBox) {
        return;
      }
      let giftBoxInput = giftBox.querySelector("input");
      giftBoxInput.checked = false;
      if (!giftBoxVariant) {
        giftBox.addClass("d-none");
        giftBoxInput.value = "";
        return;
      }
      let giftBoxLabel = giftBox.querySelector("label");
      giftBoxInput.value = giftBoxVariant.id;
      giftBoxLabel.innerHTML = giftBoxLabel.dataset.label.replace("{{money}}", giftBoxVariant.price.toCurrency());
      giftBox.removeClass("d-none");
    },
    initFormAddToCart() {
      let { formAddToCart } = this.elms;
      let btnAddToCart = formAddToCart.querySelector(".btn-add-to-cart");
      formAddToCart.addEvent("submit", (e) => {
        e.preventDefault();
        btnAddToCart.addClass("pending");
        Cart.add(formAddToCart).then(() => {
          btnAddToCart.removeClass("pending");
        });
      });
    },
    changeBundleProducts(variantId) {
      let { bundleProductsContainer } = this.elms;
      bundleProductsContainer.querySelectorAll(".bundle-products_group").addClass("d-none");
      bundleProductsContainer.querySelector(`.bundle-products_group[data-group-id="${variantId}"]`).removeClass("d-none");
      bundleProductsContainer.querySelectorAll("input").forEach((item) => item.checked = false);
      bundleProductsContainer.querySelector(`.bundle-products_group[data-group-id="${variantId}"]`).querySelectorAll("input").forEach((input) => input.checked = true);
      this.changeAddToCartNofication(variantId);
    },
    changeAddToCartNofication(variantId) {
      let { bundleProductsContainer, formAddToCart } = this.elms;
      let bundle_group = bundleProductsContainer.querySelector(`.bundle-products_group[data-group-id="${variantId}"]`);
      let button_text = bundle_group.dataset.invalid === "true" ? theme.strings.bundleUnavailable : theme.strings.addToBag;
      let submit_btn = formAddToCart.querySelector('button[type="submit"]');
      submit_btn.disabled = bundle_group.dataset.invalid === "true" ? true : false;
      submit_btn.querySelector(".btn-label").innerText = button_text;
      bundle_group.dataset.invalid === "true" ? formAddToCart.querySelectorAll(".form-group").forEach((group) => group.classList.add("d-none")) : formAddToCart.querySelectorAll(".form-group").forEach((group) => group.classList.remove("d-none"));
    }
  };

  // app/scripts/common/section/related-products.js
  var RelatedProducts = {
    onLoad: function() {
      let { container } = this;
      let sliderContainer = container.querySelector(".js-slider-container");
      let config = JSON.parse(sliderContainer.querySelector("[data-tns-config]").innerHTML);
      config.onInit = () => {
        sliderContainer.addClass("slider-initialized");
      };
      tns(config);
    }
  };

  // app/scripts/common/section/product-stories.js
  var ProductStories = {
    onLoad: function() {
      let { container } = this;
      let collapseButtons = container.querySelectorAll(".js-btn-collapse");
      collapseButtons.forEach((button) => {
        let target = button.nextElementSibling;
        button.addEvent("click", function() {
          let height = target.firstElementChild.offsetHeight;
          if (this.hasClass("active")) {
            this.removeClass("active");
            target.style.height = "";
            target.removeClass("is-open");
          } else {
            this.addClass("active");
            target.style.height = height + "px";
            target.addClass("is-open");
          }
        });
      });
    }
  };

  // app/scripts/product-page.js
  (() => {
    theme.sectionRegister.forEach((item) => {
      switch (item) {
        case "product-template":
          register(item, ProductTemplate);
          break;
        case "related-products":
          register(item, RelatedProducts);
          break;
        case "product-stories":
          register(item, ProductStories);
          break;
      }
    });
    load("*");
  })();
})();
